import {
    AnyImageOpContext,
    ImageOpInputsOrNodes,
    ImageOpNode,
    ImageOpOutputs,
} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {Evaluator} from "@cm/graph-v3"
import {registerImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/register-image-op-node"
import {definition} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/utils/lambda/definition"

const nodeDefinition = {...definition, nodeClass: "ImageOpNodeLambda"}

@registerImageOpNode
export class ImageOpNodeLambda extends ImageOpNode<typeof definition> {
    override get definition() {
        return nodeDefinition
    }

    constructor(parameters: ImageOpInputsOrNodes<typeof definition>) {
        super(parameters)
    }

    override run = async (evaluator: Evaluator<AnyImageOpContext>): Promise<ImageOpOutputs<typeof definition>> => {
        const parameters = await evaluator.getAll(this.parameters)
        return await parameters.fn(parameters.args)
    }
}
